import { AfterViewInit, Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { nuevosAlcances } from 'src/app/shared/model/gestion-proyectos/nuevosAlcances';
import { ProyectosService } from '../../proyectos.service';
import { Msg } from 'src/app/utilerias/mensajes/Msg';
import { DatePipe } from '@angular/common';

// Angular core y formularios
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

// Angular Material
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core'; // ⬅ Necesario para que funcione el datepicker con fechas nativas

// Módulo de búsqueda dentro de mat-select
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';

// DataTables para Angular


@Component({
    selector: 'app-nuevos-alcances',
    templateUrl: './nuevos-alcances.component.html',
    styleUrls: ['./nuevos-alcances.component.css'],
    standalone: true,
    imports: [
      CommonModule,
      FormsModule,
      ReactiveFormsModule,
      RouterModule,
      MatFormFieldModule,
      MatInputModule,
      MatSelectModule,
      MatIconModule,
      MatButtonModule,
      MatTooltipModule,
      MatDialogModule,
      MatDatepickerModule,
      MatNativeDateModule,
      NgxMatSelectSearchModule
    ]
})
export class NuevosAlcancesComponent implements OnInit, AfterViewInit {
  datosform: FormGroup;
  nuevoAlcance: nuevosAlcances = new nuevosAlcances();
  objectAlcance: nuevosAlcances;
  isValid = false;
  minDate: Date;
  esConsulta: boolean;
  fechaInicio: Date;
  fechaFin: Date;
  @Output() alcanceGuardado = new EventEmitter<any>();
  titulo:string

  constructor(
    private datePipe: DatePipe,
    public dialogRef: MatDialogRef<NuevosAlcancesComponent>,
    private formbuilder: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private proyectosService: ProyectosService,
    private msg: Msg
  ) { }

  ngOnInit() {
    this.datosform = this.formbuilder.group({
      dateStartCtrl: ['', Validators.required],
      dateEndCtrl: ['', Validators.required],
      descriptionProjectCtrl: ['', Validators.required],
      horasTotales: ['', Validators.required],
      horasEtc: [''],
      presupuestoAutorizado: ['']
    });
  
    if (this.data.id !== null && this.data.id !== undefined) {
      this.objectAlcance = new nuevosAlcances();
      this.objectAlcance.id_proyecto = this.data.id;
      this.minDate = new Date(this.data.fechaInicio);
      this.esConsulta = true;
      this.titulo = "Agregar nuevo "
    } else {
      this.titulo = "Información "
      this.objectAlcance = this.data as nuevosAlcances;
      this.fechaFin = new Date(this.objectAlcance.fechaFin);
      this.fechaInicio = new Date(this.objectAlcance.fechaInicio);
      this.datosform.disable();
      this.esConsulta = false;
    }
  }


  save(): void {

    this.objectAlcance.fechaFin = this.formatDate(this.fechaFin);
    this.objectAlcance.fechaInicio = this.formatDate(this.fechaInicio);

    this.proyectosService.guardarAlcance(this.objectAlcance).subscribe(res =>{
      if(res.pCodRetorno === "00000"){
        this.msg.successCall(res.pMensaje, "ÉXITO", 'Alcance guardado',)
        this.dialogRef.close(res);
      }else if(res.pMensaje){
        this.msg.warningCall(res.pMensaje, "Mensaje", null)
      }else{
        this.msg.warningCall("Lo sentimos, no se pudo guardar el alcance.", "Mensaje", null)
      }
    })
  }

  formatDate(date: Date): string {
    return this.datePipe.transform(date, 'yyyy-MM-dd');
  }

  isValidDates(): boolean {
    if (!this.datosform.controls.dateStartCtrl.value || !this.datosform.controls.dateEndCtrl.value) {
      return false; 
    }
  
    const startDate = new Date(this.datosform.controls.dateStartCtrl.value);
    const endDate = new Date(this.datosform.controls.dateEndCtrl.value);
  
    if (startDate.getTime() <= endDate.getTime()) {
      return true; 
    } else {
      return false; 
    }
  }

  ngAfterViewInit(): void {
    this.isValid = false;

  }

  onNoClick(): void {
    this.dialogRef.close();
  }

}
